<app-product-files-prompt [sectionNumber]="2"
                          sectionTitle="Damage Photo"
                          heroTitle="Next we’ll need a photo of the damage."
                          heroImage="assets/consumer-mobile/damage-file.svg"
                          messageBody="Focus on the area of furniture where the damage is located. For example, if it is a stain on a seat cushion, the photo should show the entire seat cushion."
                          (goToNextStep)="goToCloseupFileUpload()"></app-product-files-prompt>
